import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchApprovalRequests } from '../api/auth';
import styles from './AppMessageNotifier.module.css';

export default function AppApprovalNotifier({ isAuthenticated, currentUser }) {
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);
  const previousPendingRef = useRef(0);
  const isSuperadmin = currentUser?.role === 'admin' && currentUser?.isSuperadmin === true;

  useEffect(() => {
    if (!isAuthenticated || !isSuperadmin) {
      previousPendingRef.current = 0;
      setToast(null);
      return undefined;
    }

    let cancelled = false;

    const loadSummary = async () => {
      try {
        const result = await fetchApprovalRequests(12);
        if (cancelled) return;
        const requests = Array.isArray(result?.requests) ? result.requests : [];
        const pending = requests.filter((request) => request?.status === 'pending');
        const nextPending = pending.length;
        const latestPending = pending[0] || null;
        if (nextPending > previousPendingRef.current && latestPending) {
          setToast({
            username: latestPending.username || 'New user',
            email: latestPending.email || '',
            count: nextPending,
          });
        }
        previousPendingRef.current = nextPending;
      } catch (error) {
        console.warn('Approval request summary failed:', error);
      }
    };

    loadSummary();
    const interval = window.setInterval(loadSummary, 20000);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [isAuthenticated, isSuperadmin]);

  useEffect(() => {
    if (!toast) return undefined;
    const timeout = window.setTimeout(() => setToast(null), 6000);
    return () => window.clearTimeout(timeout);
  }, [toast]);

  if (!isAuthenticated || !isSuperadmin || !toast) return null;

  return (
    <button
      type="button"
      className={styles.toast}
      style={{ bottom: 108 }}
      onClick={() => {
        navigate('/admin');
        setToast(null);
      }}
    >
      <span className={styles.badge}>Pending approval</span>
      <strong>{toast.username}</strong>
      <p>{toast.email || `${toast.count} pending approval request(s) need review.`}</p>
      <em>Open admin panel</em>
    </button>
  );
}
